import React from 'react';

import Spinner from 'components/Spinner';
import KeyIndicatorsCard from '../components/KeyIndicatorsCard';

import { useDistributionKpi } from 'apiTyped/hooks/distribution.query';

const Kpi = ({ form }) => {
  // Use the new hook to fetch KPI data
  const { isLoading, data } = useDistributionKpi(
    form.currentCampaign?.id,
    form.wineType
  );

  return (
    <React.Fragment>
      <KeyIndicatorsCard
        data={data}
        currentCampaign={form.currentCampaign}
        form={form}
      />
      <Spinner loading={isLoading} />
    </React.Fragment>
  );
};

export default Kpi;
